<template> 
    <div>
        <Accordion :activities="activities"/>
        <Cards class="margin-center" :posts="posts"/>
    </div>
</template>

<script>
import getPosts from '@/composables/getposts'
import Cards from '@/components/Cards'
import Accordion from '@/components/Accordion.vue'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
export default {
    components: { Cards, Accordion },
    setup() {


        const { posts } = getPosts()
        const route = useRoute() 


        const activities = computed(() => {
            return posts.value.filter(post => post.id == route.params.id)
        })

        return { posts, route, activities }
    }

}
</script>

<style>


</style>